module.exports = __webpack_public_path__ + "img/miro_512x512.f2a6c3b8.png";